Handlebars.registerPartial('partials/uitk/map-marker-pin', Handlebars.template({"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    return "<span class=\"theme-map-marker marker marker-tooltip marker-pin\"></span>";
},"useData":true}));